import React from 'react';
// custom
import LoginCard from '../../components/cards/login/Login.card';

function LoginView() {
    return (   
      <React.Fragment>
          <div className="h-screen bg-gray-200 dark:bg-gray-800 flex justify-center items-center">
              <LoginCard />
          </div>          
      </React.Fragment>
    );
}

export default LoginView;